export default __webpack_public_path__ + "static/media/WEC.14d84b68.png";